export default "__VITE_ASSET___qsYknu___"